import React from 'react';
import { Button } from 'react-bootstrap';
import { Receipt, Save } from 'lucide-react';

import SettingsCard from '../SettingsCard';
import CompanyVatFields from './CompanyVatFields';
import VatDeductionProfileSection from './VatDeductionProfileSection';
import VatRegistrationHistorySection from './VatRegistrationHistorySection';

// Moms — one place for every VAT setting.
//
// These were split across two pages that neither named moms: momsnummer,
// momsstatus, undantagsgrund and momsprofil sat inside the Företagsuppgifter
// form, while avdragsprofilen and registreringshistoriken sat at the bottom of
// the 35-screen Bokföring page. Same save endpoint as before — the fields still
// write through the shell's saveCompanyDetails.
const VatSection = ({
  companyId,
  companyDetails,
  setCompanyDetails,
  saveCompanyDetails,
  fiscalYears,
}) => (
  <>
    <SettingsCard
      id="momsregistrering"
      icon={Receipt}
      title="Momsregistrering"
      subtitle="Momsnummer, momsstatus och de uppgifter som styr momsdeklarationens förfallodag"
      actions={
        <Button variant="primary" onClick={saveCompanyDetails}>
          <Save size={16} className="me-2" />
          Spara
        </Button>
      }
    >
      <CompanyVatFields
        companyDetails={companyDetails}
        setCompanyDetails={setCompanyDetails}
        companyId={companyId}
      />
    </SettingsCard>

    {/* Avdragsprofil för moms — blandad verksamhet (G9). Per räkenskapsår. */}
    <VatDeductionProfileSection companyId={companyId} fiscalYears={fiscalYears} />

    {/* Momsregistreringens beslutshistorik (D9/B3) — read-only, and silent
        when there is nothing recorded. */}
    <VatRegistrationHistorySection companyId={companyId} />
  </>
);

export default VatSection;
